export const UPDATE_CHILDREN_SESSION = 'UPDATE_CHILDREN_SESSION'
export const UPDATE_CHILDREN_SESSION_SUCCESS = 'UPDATE_CHILDREN_SESSION_SUCCESS'
export const UPDATE_CHILDREN_SESSION_FAILED = 'UPDATE_CHILDREN_SESSION_FAILED'
